// Utils
import { YChartsSentryUtils } from 'NewAngular/services/sentry/sentry-utils';
import * as i0 from "@angular/core";
export class AIStreamingService {
    /**
     * Makes a request to AI Proxy and handles the server-sent events in the response.
     *
     * @param url relative URL of the AI Proxy endpoint to call, e.g. "/news"
     * @param handlers handlers for the default events.
     * The "token" handler runs each time a token is recieved.
     * The "error" handler runs if an error occurs with the connection.
     * The "done" handler runs when the server is done sending events.
     * @param customHandlers handlers for custom events.
     */
    stream(url, handlers, customHandlers = {}) {
        const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:3003' : process.env.AI_PROXY_BASE_URL;
        const stream = new EventSource(`${baseUrl}/${url}`, {
            withCredentials: true,
        });
        const defaultHandlers = {
            error: () => { },
            done: () => { },
        };
        const mergedHandlers = {
            ...defaultHandlers,
            ...handlers,
        };
        // Configure handling of default events
        stream.onmessage = (event) => {
            // Newline characters are URL-encoded as %0A so that they don't interfere with the server-sent events protocol.
            // We decode them here to preserve the formatting of the original response.
            mergedHandlers.token(event.data.replace(/%0A/g, '\n'));
        };
        stream.onerror = (e) => {
            mergedHandlers.error();
            YChartsSentryUtils.captureException(e);
            stream.close();
        };
        stream.addEventListener('done', () => {
            mergedHandlers.done();
            stream.close();
        });
        // Configure handling of custom events
        Object.keys(customHandlers).forEach((customEventName) => {
            stream.addEventListener(customEventName, customHandlers[customEventName]);
        });
    }
}
AIStreamingService.ɵfac = function AIStreamingService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AIStreamingService)(); };
AIStreamingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AIStreamingService, factory: AIStreamingService.ɵfac, providedIn: 'root' });
